import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';

const Price = ({ amount, fromCurrency = 'EUR', className = '', showSymbol = true, decimals = 2 }) => {
  const { formatPrice } = useCurrency();
  
  if (!amount && amount !== 0) return null;
  
  return (
    <span className={className}>
      {formatPrice(amount, fromCurrency, showSymbol, decimals)}
    </span>
  );
};

export default Price;
